<template>
  <header class="checkout--header">
    <div class="container">
      <div class="logo">
        <a v-bind:href="homeURL">
          <img :src="logos.mobileAlternateUri" />
        </a>
      </div>

      <steps />

      <countdown v-if="!steps.confirmation && (shoppingCart && shoppingCart.expiresAt || order && order.expiresAt)"/>

      <button
        @click="abandonCart()"
        v-if="!steps.confirmation"
        class="close"
      ></button>

      <a href="/" v-if="steps.confirmation" class="close"></a>
    </div>
  </header>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

import Steps from '@vue/views/checkout/common/steps'
import Countdown from '@vue/common/components/countdown'

export default {
  name: 'CheckoutHeader',
  components: {
    Steps,
    Countdown
  },
  data() {
    return {
      homeURL: window.navigationSettings.homeURL
    }
  },
  computed: {
    ...mapState({
      shoppingCart: (state) => state.cart.shoppingCart,
      steps: (state) => state.checkout.steps,
      order: (state) => state.checkout.order
    }),

    logos() {
      return window.logoUriSettings;
    }
  },
  methods: {
    ...mapActions({
      getCheckoutContent: 'checkout/getCheckoutContent',
      abandonCart: 'cart/abandonCart'
    })
  },
  async mounted() {
    await this.getCheckoutContent()
  }
}
</script>
